<template>
  <div
    class="flex items-center py-2 px-3 gap-2 bg-primary rounded-md shadow-xs"
  >
    <div class="flex items-center justify-between grow gap-2 truncate">
      <div class="flex items-center gap-3 truncate">
        <Indicator
          variant="asset"
          :size="!isMobile ? 'sm' : 'xs'"
          mode="transparent"
          :imageUrl="asset.thumbnailUrl"
        />
        <span
          class="w-full font-medium truncate"
          :class="{
            'text-style-base': viewport !== 'desktop',
            'text-style-sm': viewport === 'desktop',
            'lg:text-style-sm': viewport === 'reactive',
          }"
        >
          <TextWithTooltip
            :title="asset.name"
            :listeners="[width]"
            :lines="1"
          />
        </span>
      </div>
      <div class="max-w-40">
        <IdWithTooltip
          v-if="asset.identifier"
          :label="asset.identifier"
          :listeners="[width]"
        />
      </div>
    </div>
    <div class="flex items-center" @click.stop>
      <Actions
        :asset="asset"
        :size="isMobile ? 'sm' : 'xs'"
        :canUpdate="canUpdate"
        @unlink="$emit('unlink', asset)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Indicator } from "@/SharedComponents/Indicator";
import { Actions } from "@/SharedComponents/Passport/Asset";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { IdWithTooltip } from "@/SharedComponents/IdWithTooltip";
import { TextWithTooltip } from "@/SharedComponents/TextWithTooltip";

const props = defineProps({
  asset: { type: Object, required: true },
  canUpdate: { type: Boolean, required: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const { maxTablet, width } = useBreakpoints();

const isMobile = computed(() => {
  switch (props.viewport) {
    case "mobile":
      return true;
    case "desktop":
      return false;
    case "reactive":
    default:
      return maxTablet.value;
  }
});
</script>
